import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Bike, Car, User, LogIn, ShieldCheck } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

export default function MotoShell({ children }) {
  const { user, openLogin, openRegister } = useAuth();
  const navigate = useNavigate();

  const goDashboard = () => {
    if (user?.role === 'enseignant') navigate('/enseignant/dashboard');
    else if (user?.role === 'secretaire') navigate('/secretariat');
    else if (user?.is_admin) navigate('/admin');
    else navigate('/eleve/dashboard');
  };

  return (
    <div className="min-h-screen bg-[#070a12] text-white">
      <header className="sticky top-0 z-40 bg-[#070a12]/90 backdrop-blur-md border-b border-white/5">
        <div className="max-w-7xl mx-auto px-4 lg:px-6 h-[68px] flex items-center justify-between">
          <Link to="/moto" className="flex items-center gap-2.5" data-testid="moto-shell-logo">
            <span className="w-10 h-10 rounded-xl bg-sky-500 flex items-center justify-center text-white"><Bike size={20} /></span>
            <span className="font-serif-editorial text-[20px] leading-none">Code <span className="text-sky-400">2 Roues</span></span>
          </Link>
          <nav className="hidden md:flex items-center gap-6 text-[13.5px] text-white/75">
            <Link to="/moto/enquetes" className="hover:text-white transition" data-testid="moto-nav-magazine">Magazine</Link>
            <Link to="/moto/apprendre" className="hover:text-white transition" data-testid="moto-nav-etm">Code ETM</Link>
            <Link to="/moto/plateau" className="hover:text-white transition" data-testid="moto-nav-plateau">Plateau</Link>
            <Link to="/moto/livret" className="hover:text-white transition" data-testid="moto-nav-livret">Livret</Link>
            <a href="https://codevoiture.fr" target="_blank" rel="noopener noreferrer" className="hover:text-white transition inline-flex items-center gap-1.5"><Car size={13} /> Code Voiture</a>
          </nav>
          <div className="flex items-center gap-2">
            {user ? (
              <button onClick={goDashboard} data-testid="moto-dashboard-btn" className="h-10 px-4 rounded-full bg-sky-500 hover:bg-sky-400 text-black text-[13px] font-bold inline-flex items-center gap-1.5 transition-colors">
                <User size={14} /> Mon espace
              </button>
            ) : (
              <>
                <button onClick={openLogin} data-testid="moto-login-btn" className="h-10 px-4 rounded-full border border-white/15 text-white/85 hover:text-white text-[13px] font-semibold inline-flex items-center gap-1.5 transition-colors">
                  <LogIn size={13} /> Connexion
                </button>
                <button onClick={openRegister} data-testid="moto-register-btn" className="hidden sm:inline-flex h-10 px-4 rounded-full bg-sky-500 hover:bg-sky-400 text-black text-[13px] font-bold items-center gap-1.5 transition-colors">
                  Créer un compte
                </button>
              </>
            )}
          </div>
        </div>
      </header>

      {children}

      <footer className="mt-16 border-t border-white/5 bg-[#05070d]">
        <div className="max-w-7xl mx-auto px-4 lg:px-6 py-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="text-white/45 text-[12.5px] leading-relaxed max-w-md">
            <span className="inline-flex items-center gap-1.5 text-white/70 font-semibold"><ShieldCheck size={13} /> Code 2 Roues · hub LLB ECSR</span><br />
            Plateforme pédagogique gratuite, sans pub ni tracking, conçue par des moniteurs ECSR.
          </div>
          <div className="flex flex-wrap gap-4 text-[12.5px] text-white/55">
            <a href="https://codevoiture.fr" target="_blank" rel="noopener noreferrer" className="hover:text-white transition">codevoiture.fr</a>
            <Link to="/nos-plateformes" className="hover:text-white transition">Nos plateformes</Link>
            <Link to="/mentions-legales" className="hover:text-white transition">Mentions légales</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
